import React, {useState} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../shared/helpers/src/internationalization/react';
import {Button} from '../../../../shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../shared/ui/src/components/buttons/buttonConstants';
import {fontWeights} from '../../../../shared/ui/src/styles/fontStyles';
import {baseUrl, BasicForm, BasicFormState} from '../components/settings/basicForm';

/*
 * Styles.
 */

const StyledPageWrapperDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const StyledHeaderDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 32px 48px;
  width: 100%;
`;

const StyledHeaderTextDiv = styled.div`
  color: ${(p) => p.theme.greys.shade90};
  font-size: 24px;
  font-weight: ${fontWeights.black};
`;

const StyledFormWrapperDiv = styled.div`
  padding: 32px 48px;
  flex: 1;
`;

const StyledFooterWrapperDiv = styled.div`
  margin: 0 48px;
  padding: 16px 0;
  border-top: 2px solid ${(p) => p.theme.greys.shade20};
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  align-items: center;
`;

/*
 * Component.
 */

export const Settings = () => {
  const [basicFormState, setBasicFormState] = useState<BasicFormState>({
    name: {value: '', isValid: false, touched: false},
    url: {value: baseUrl, isValid: false, touched: false},
  });

  return (
    <StyledPageWrapperDiv>
      <StyledHeaderDiv>
        <StyledHeaderTextDiv>
          <Trans id="knowledge-base-settings-page-header">Settings</Trans>
        </StyledHeaderTextDiv>
        <Button variant={ButtonVariantsEnum.SECONDARY} rightIcon="externalLinkSmall">
          <Trans id="knowledge-base-settings-visit-site-button">Visit site</Trans>
        </Button>
      </StyledHeaderDiv>
      <StyledFormWrapperDiv>
        <BasicForm formState={basicFormState} onChange={setBasicFormState} />
      </StyledFormWrapperDiv>
      {hasChanges(basicFormState) && (
        <StyledFooterWrapperDiv>
          <Button variant={ButtonVariantsEnum.SECONDARY}>
            <Trans id="knowledge-base-settings-cancel">Cancel</Trans>
          </Button>
          <Button variant={ButtonVariantsEnum.PRIMARY} isDisabled={!isFormValid(basicFormState)}>
            <Trans id="knowledge-base-settings-save">Save</Trans>
          </Button>
        </StyledFooterWrapperDiv>
      )}
    </StyledPageWrapperDiv>
  );
};

/*
 * Helpers.
 */

function hasChanges(basicFormState: BasicFormState) {
  return basicFormState.name.touched || basicFormState.url.touched;
}

function isFormValid(basicFormState: BasicFormState) {
  return basicFormState.name.isValid && basicFormState.url.isValid;
}
